import Model from "../../model"
import assert from "../../../services/assert"
import { ID, SourceType } from "../../types"

import Command, { CommandName } from "../command"

export type SetIdeaSourceCommandState = {
  id: ID
  sourceType: SourceType | null
  sourceId: ID | null
  updatedAt?: Date
  captured?: {
    prevSourceType: SourceType | null
    prevSourceId: ID | null
  }
}

export default class SetIdeaSourceCommand extends Command {
  name: CommandName = "set-idea-source"
  state: SetIdeaSourceCommandState

  constructor(state: SetIdeaSourceCommandState) {
    super()
    this.state = state
    assert(state.sourceType !== "web" || state.sourceId)
  }

  // Possible conflicts:
  //   - idea might have been deleted (Cancel)
  //   - source might have been deleted (Cancel)
  resolveConflicts(model: Model): SetIdeaSourceCommandState | null {
    const idea = model.getIdea(this.state.id)
    if (!idea) return null
    if (
      this.state.sourceType == "web" &&
      this.state.sourceId &&
      !model.getSource(this.state.sourceId)
    )
      return null
    return this.state
  }

  local(model: Model): any {
    const idea = model.fetchIdea(this.state.id)
    this.state.captured = {
      prevSourceType: idea.sourceType,
      prevSourceId: idea.sourceId,
    }
    model.setIdeaSource(
      this.state.id,
      this.state.sourceType,
      this.state.sourceId,
      this.state.updatedAt,
    )
  }

  undo(): Command[] {
    if (!this.state.captured) throw new Error("No captured state")
    return [
      new SetIdeaSourceCommand({
        id: this.state.id,
        sourceType: this.state.captured.prevSourceType,
        sourceId: this.state.captured.prevSourceId,
      }),
    ]
  }
}
